import React, { useEffect, useRef, useState } from 'react';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { Container, ColumnSeparator, CustomTableCell } from './styles';

export interface CustomGridColumns {
  field: string;
  headerName: string;
  width: number;
  minWidth?: number;
  align?: string;
  fixed?: boolean;
  hide?: boolean;
  sortable?: boolean;
  disableColumnMenu?: boolean;
  renderCell?: (row: any) => void;
  fixedDirection?: string;
}

interface FormProps {
  rows: any[];
  columns: CustomGridColumns[];
  stickyMenuBackground?: string;
}

/**
 * Linhas e colunas para exemplo
 */

/**
 * @param rows Array de objetos contendo as linhas da tabela (as keys dos objetos devem ser iguais as ids das colunas)
 * @param columns Array de objetos contendo as colunas
 * @param columns Para fixar uma coluna basta passar uma chave chamada fixed com o valor true e Left com 0 (também é necessário passar um width e um minWidth)
 * @param columns Caso mais de uma coluna seja fixa, a coluna seguinte deverá receber o valor de Left igual ao minWidth da coluna anterior
 * @returns Componente DataGrid personalizado
 */

export const CustomDataGrid: React.FC<FormProps> = (props) => {
  const { rows, columns, stickyMenuBackground } = props;

  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const tableRef = useRef<any>();

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  return (
    <Container>
      <Paper
        style={{
          width: '100%',
          height: '100%',
          flex: 1,
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TableContainer
          style={{
            flex: 1,
          }}
          ref={tableRef}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns
                  .filter((column) => column.hide !== true)
                  .map((column) => {
                    if (column.fixed)
                      return (
                        <TableCell
                          key={column.field}
                          className="text-truncate"
                          style={{
                            position: 'sticky',
                            right: 0,
                            width: column.width,
                            minWidth: column.width,
                            background: '#57069e',
                            zIndex: 2,
                            textAlign: 'center',
                          }}
                        >
                          {column.headerName}
                        </TableCell>
                      );
                    return (
                      <TableCell
                        key={column.field}
                        className="text-truncate"
                        style={{
                          minWidth: column.minWidth
                            ? column.minWidth
                            : column.width,
                          position: 'relative',
                          zIndex: 0,
                        }}
                      >
                        {column.headerName}
                        <ColumnSeparator>
                          <svg
                            className="MuiSvgIcon-root MuiDataGrid-iconSeparator"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                          >
                            <path d="M11 19V5h2v14z" />
                          </svg>
                        </ColumnSeparator>
                      </TableCell>
                    );
                  })}
                {/* {columns} */}
              </TableRow>
            </TableHead>
            <TableBody>
              {/* {columns.filter((column) => column.hide !== true)} */}
              {rows

                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, rowIndex) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      // eslint-disable-next-line react/no-array-index-key
                      key={rowIndex}
                      style={{
                        borderColor: '#8850BF',
                      }}
                    >
                      {columns
                        .filter((column) => column.hide !== true)
                        .map((column) => {
                          if (column.fixed)
                            return (
                              <CustomTableCell
                                key={column.field}
                                background={stickyMenuBackground}
                                columnWidth={column.width}
                              >
                                {column.renderCell
                                  ? column.renderCell(row)
                                  : row[column.field]}
                              </CustomTableCell>
                            );
                          return (
                            <TableCell key={column.field}>
                              {column.renderCell
                                ? column.renderCell(row)
                                : row[column.field]}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[-1]}
          onPageChange={handleChangePage}
          count={rows.length}
          page={page}
          rowsPerPage={rowsPerPage}
        />
      </Paper>
    </Container>
  );
};
